module.exports = __webpack_public_path__ + "static/media/45.9c0c9b77.JPG";